<template>
  <div
    :class="{
      'animated fadeIn employee-form': true,
      'form-crate': mData.viewMode == 'create',
      'form-update': mData.viewMode != 'create',
    }"
  >
    <div class="card">
      <div class="main-card-body d-flex">
        <div class="div-list" v-if="mData.viewMode != 'create'">
          <div class="search">
            <el-form class="form-search" ref="myForm" @submit.native.prevent :model="mData.dataSearch.value"
              :rules="mData.dataSearch.valid">
              <el-input prefix-icon="isax-search-normal" placeholder="Tìm kiếm nhân viên"
                v-model="mData.dataSearch.value.condition" @change="fn_findEmployee()"></el-input>
            </el-form>
            <!-- <div class="show-hide-tab" @click="showHineTabEmployee()">
              <el-image class="icon" src="img/arrow-square-right.png" fit="cover"></el-image>
            </div> -->
          </div>
          <div class="pr-2">
            <div class="title__list-employee">
              <h5 class="pt-2 mb-0">Danh sách nhân viên</h5>
            </div>
            <div class="mt-1 list-employee">
              <div class="text-center" style="width: 100%;" v-if="mData.dataDefault.dataListEmployee.length == 0">
                <span class="title__empty-text">Không có dữ liệu</span>
              </div>
              <div v-if="mData.dataDefault.dataListEmployee.length > 0" v-infinite-scroll="load"
                infinite-scroll-distance="5">
                <div v-for="(item, index) in mData.dataDefault.dataListEmployee" :key="index">
                  <el-card class="box-card mb-3  postion-relative"
                    :id="mData.routerParamId === item.id ? 'active-tb' : ''">
                    <div class="icon-haveDraff" v-if="checkHaveDraff(item.id)" title="Cần duyệt thông tin"
                      @click="emitGlobalRowApprovedClicked(item)">
                      <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="d-flex" @click="emitGlobalRowClicked(item)">

                      <div class="e-avatar mr-3">
                        <el-image :src="item.avataUrl ? item.avataUrl : 'img/demo.png'" fit="cover"></el-image>
                      </div>
                      <div class="e-information">
                        <p class="e-information__name">
                          {{
                            item.administrative_info &&
                              item.administrative_info.name &&
                              item.administrative_info.name &&
                              item.administrative_info.name.full_name ?
                              item.administrative_info.name.full_name : ""
                          }}
                        </p>
                        <p class="e-information__position">
                          {{
                            item.chuc_vu &&
                              item.chuc_vu.trim() != "" ?
                              item.chuc_vu : "....."
                          }}
                        </p>
                        <p class="e-information__no">
                          Mã NV: {{
                            item.employee_no ?
                              item.employee_no : "....."
                          }}
                        </p>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="mData.viewMode == 'create' || viewByTable === true ? 'div-main-create' : 'div-main'">
          <div class="body-header d-flex justify-content-between align-items-center mr-3 mb-3">
            <div class="text-left title-body-header w-60">
              <h3 v-if="mData.viewMode == 'create'">Thêm mới nhân viên</h3>
              <h3 v-if="mData.viewMode == 'update' || mData.viewMode == 'detail'">Chi tiết nhân viên</h3>
              <h3 v-if="mData.viewMode == 'approve'">Duyệt thông tin nhân viên</h3>
            </div>
            <div class="div-btn text-right w-100">
              <el-button class="btn-default" round @click="fn_go()">
                Quay lại
                <i class="icon-Undo"></i>
              </el-button>
              <el-button v-if="
                mData.viewMode == 'create' &&
                mData.dataDefault.listFeature.includes('FT103')
              " @click="fn_submitForm('create')" class="pl-2 btn-default" type="primary" round>
                Thêm mới
                <i class="icon-Edit"></i>
              </el-button>
              <el-button v-if="
                mData.viewMode == 'update' &&
                mData.dataDefault.listFeature.includes('FT104')
              " @click="fn_submitForm('update')" class="pl-2 btn-default" type="primary" round>
                Cập nhật
                <i class="icon-Edit"></i>
              </el-button>
              <el-button v-if="
                mData.viewMode == 'update' &&
                mData.dataDefault.listFeature.includes('FT104')
              " @click="fn_submitForm('delete')" class="pl-2 btn-default" type="danger" round>
                Xóa
                <i class="isax-trash icon_sax"></i>
              </el-button>
              <el-button v-if="
                mData.viewMode == 'approve' &&
                mData.dataDefault.listFeature.includes('FT104')
              " type="success" round @click="approveDraff('approve')">
                Duyệt
                <i class="isax-card-tick icon_sax"></i>
              </el-button>
              <el-button v-if="
                mData.viewMode == 'approve' &&
                mData.dataDefault.listFeature.includes('FT104')
              " class="btn-back" type="danger" round @click="approveDraff('disapprove')">
                Từ chối
                <i class="isax-card-slash icon_sax"></i>
              </el-button>
            </div>
          </div>
          <div v-if="mData.viewMode == 'create'" class="employee_infomation">
            <HoSoCaNhan></HoSoCaNhan>
          </div>
          <div v-if="mData.viewMode != 'create'"
            :class="mData.viewMode == 'create' ? 'data_list_employee ml-0' : 'data_list_employee'">
            <div class="tab-css">
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="Hồ sơ cá nhân" name="HSCN">
                  <HoSoCaNhan v-if="currentTab == 'HSCN' && (mData.viewMode == 'update' || mData.viewMode == 'detail')">
                  </HoSoCaNhan>
                  <ThongTinNhanVien v-if="mData.viewMode == 'approve'" :haveDraff="true" :dataDraff="getDataDraffProp()"
                    :viewType="'approveInfomation'" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="(mData.viewMode == 'update' || mData.viewMode == 'detail') && mData.dataDefault.listFeature.includes('FT1701')"
                  label="Hợp đồng" name="HopDong">
                  <HopDong v-if="currentTab == 'HopDong'"></HopDong>
                </el-tab-pane>
                <el-tab-pane
                  v-if="(mData.viewMode == 'update' || mData.viewMode == 'detail') && mData.dataDefault.listFeature.includes('FT1501')"
                  label="Tài sản" name="TaiSan">
                  <TaiSan v-if="currentTab == 'TaiSan'" :offSetListEmployee="mData.endSliceValue"
                    :isBeforeEmployee="isBeforeEmployee"></TaiSan>
                </el-tab-pane>
                <el-tab-pane v-if="(mData.viewMode == 'update' || mData.viewMode == 'detail')" label="Phân quyền"
                  name="PhanQuyen">
                  <PhanQuyen v-if="currentTab == 'PhanQuyen'"></PhanQuyen>
                </el-tab-pane>
                <el-tab-pane v-if="(mData.viewMode == 'update' || mData.viewMode == 'detail')" label="Nghỉ phép"
                  name="NghiPhep">
                  <NghiPhep v-if="currentTab == 'NghiPhep'"></NghiPhep>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService'
import DataService from '../../../service/DataService'
import MethodService from "../../../service/MethodService"
import ExtensionService from "../../../service/ExtensionService"
import EmployeeModel from "./EmployeeModel"
import HoSoCaNhan from "../../../component/NhanVien/HoSoCaNhan"
import ThongTinNhanVien from '../../../component/NhanVien/ThongTinNhanVien'
import HopDong from "../../../component/NhanVien/HopDong"
import TaiSan from "../../../component/NhanVien/TaiSan"
import QuanLyTaiLieu from "../../../component/NhanVien/QuanLyTaiLieu"
import PhanQuyen from "../../../component/NhanVien/PhanQuyen"
import NghiPhep from "../../../component/NhanVien/NghiPhep"
import QuyTrinh from "../../../component/NhanVien/QuyTrinh"
import EmployeeApi from '../../../moduleApi/EmployeeApi'
import PositionApi from '../../../moduleApi/PositionApi'
import EmployeeDraffApi from "../../../moduleApi/EmployeeDraffApi"
import EmployeeSignatureDraffApi from "../../../moduleApi/EmployeeSignatureDraffApi"
import EventBus from "../../../service/EventBus"

export default {
  components: {
    HoSoCaNhan,
    ThongTinNhanVien,
    HopDong,
    TaiSan,
    QuanLyTaiLieu,
    PhanQuyen,
    NghiPhep,
    QuyTrinh,
  },
  data() {
    return {
      showPagenation: true,
      activeName: "HSCN",
      currentTab: 'HSCN',
      query: {},
      imgUrl: ExtensionService.urlImg,
      totalEmployee: 0,
      viewByTable: undefined,
      dataFilter: {
        filters: "",
        limit: 20,
        offset: 0,
        page: 1,
        sort: "administrative_info.name.first_name"
      },
      mData: {
        rowId: undefined,
        routerParamId: "",
        moduleName: "EmployeeManager", //requied
        viewMode: "",
        tableRules: MethodService.copyObject(EmployeeModel.tableRules),
        dataSearch: {
          value: {
            condition: ""
          },
          valid: {
            condition: []
          },
          operator: {
            "condition": "$vn_text=", //:regex:, $vn_text=Viêt nam
          }
        },
        endSliceValue: 0,
        dataDefault: {
          listChiNhanh: [],
          listPhongBan: [],
          listChucVu: [],
          listTrangThai: [],
          dataListEmployee: [],
          dataListEmployeeClone: [],
          listEmployeeDraff: [],
          listEmployeeSignatureDraff: [],
          listFeature: MethodService.getListFeatures(),
        },
        currentPath: "",
        totalEmployee: 0,
      },
      isBeforeEmployee: true,
    };
  },

  methods: {
    showHineTabEmployee() {

    },
    async load() {
      await this.fn_getEmployeeList()
      if (this.mData.dataDefault.dataListEmployee.length == this.mData.dataDefault.dataListEmployeeClone.length) return
      this.mData.endSliceValue += 20
      this.mData.dataDefault.dataListEmployee = this.mData.dataDefault.dataListEmployeeClone.slice(0, this.mData.endSliceValue)
      localStorage.setItem('offSetEmployee', this.mData.endSliceValue)
    },
    async fn_innitDataDefault() {
      if (this.$router.currentRoute.query) {
        this.dataFilter = this.$router.currentRoute.query
      }
      let offSetEmployee = localStorage.getItem('offSetEmployee')
      this.mData.endSliceValue = this.$router.currentRoute.query.offset ? parseInt(this.$router.currentRoute.query.offset) + 20 : parseInt(offSetEmployee ? offSetEmployee : 20)
      localStorage.setItem('offSetEmployee', this.mData.endSliceValue)
      this.dataFilter.limit = DataService.setMaxEmployee
      const positionApiReq = await PositionApi.list({ limit: 1000 }, true)
      const positionApiRes = await positionApiReq
      this.mData.dataDefault.listChucVu = positionApiRes.result
    },
    async fn_getEmployeeList() {
      if (this.dataFilter.filters) {
        let m1 = this.dataFilter.filters.match(/\$vn_text=([^&]*)(&|$)/)
        if (m1) {
          this.$set(this.mData.dataSearch.value, 'condition', decodeURIComponent(m1[1]))
        }
      }
      this.dataFilter.offset = 0
      this.dataFilter.page = 1
      this.$router.replace({
        name: this.$router.currentRoute.name,
        params: { id: this.$router.currentRoute.params.id },
        query: {
          tab: this.activeName,
          filters: this.dataFilter.filters,
          off: this.mData.endSliceValue
        }
      }).catch((err) => { })
      const companyInfo = MethodService.getCompanyInfo();
      if (companyInfo && companyInfo.id) {
        this.dataFilter.companyId = companyInfo.id;
      }
      const employeeList = await EmployeeApi.list(this.dataFilter, true)
      employeeList.result = Array.isArray(employeeList.result) ? employeeList.result : []
      employeeList.result.forEach(e => {
        if (e.image_id) {
          e.avataUrl = ExtensionService.urlImg + e.image_id
        } else if (e.administrative_info && e.administrative_info.avatar_id) {
          e.avataUrl = ExtensionService.urlImg + e.administrative_info.avatar_id
        } else {
          e.avataUrl = 'img/demo.png'
        }
        e.chuc_vu = ""

      })
      let resData = await this.fn_changeData(employeeList.result)
      let arrEmployeeIds = MethodService.findListItemDifferent(resData, 'id')
      await this.getDataEmployeeDraff(arrEmployeeIds)
      this.mData.dataDefault.dataListEmployeeClone = resData
      this.mData.dataDefault.dataListEmployee = this.mData.dataDefault.dataListEmployeeClone.slice(0, this.mData.endSliceValue)
      this.$forceUpdate()
    },
    fn_changeData(data) {
      let curentTime = new Date().getTime()
      let employeeData = Array.isArray(data) ? data : []
      employeeData.forEach((item, index) => {
        let validJobInfo = (item.job_info || []).filter((e) => {
          if (e.end_date) {
            return (
              new Date(e.start_date).getTime() <= curentTime &&
              curentTime <= new Date(e.end_date).getTime()
            )
          } else {
            return new Date(e.start_date).getTime() <= curentTime
          }
        })
        let chucVu = (this.mData.dataDefault.listChucVu || []).find((element) => {
          return (
            element.id ==
            (validJobInfo[0] && validJobInfo[0].position_id
              ? validJobInfo[0].position_id
              : "")
          )
        })
        if (chucVu && chucVu.name) {
          item.chuc_vu = chucVu.name
        } else {
          item.chuc_vu = " "
        }
      })
      return employeeData
    },
    scrollToActiveEmployee(delay = 0) {
      setTimeout(() => {
        const element = document.getElementById('active-tb')
        if (element && typeof element.scrollIntoView === 'function') {
          element.scrollIntoView()
        }
      }, delay)
    },
    async getDataEmployeeDraff(arrIds) {
      const employeeDraffApiRes = await EmployeeDraffApi.list({
        limit: arrIds.length,
        filters: `employee_id:in:${arrIds.join(',')}&approver:is_null:true`
      }, true)
      const employeeSignatureDraffApiRes = await EmployeeSignatureDraffApi.list({
        limit: arrIds.length,
        filters: `employee_id:in:${arrIds.join(',')}&approver:is_null:true`
      }, true)
      this.mData.dataDefault.listEmployeeDraff = employeeDraffApiRes.result
      this.mData.dataDefault.listEmployeeSignatureDraff = employeeSignatureDraffApiRes.result
    },
    getDataDraffProp() {
      return this.mData.dataDefault.listEmployeeDraff.find((e) => e.employee_id == this.mData.rowId)
    },
    checkHaveDraff(employeeId) {
      let employeeDraff = this.mData.dataDefault.listEmployeeDraff.find(item => item.employee_id == employeeId)
      let employeeSignatureDraff = this.mData.dataDefault.listEmployeeSignatureDraff.find(item => item.employee_id == employeeId)
      if (employeeDraff || employeeSignatureDraff) {
        return true
      }
      return false
    },
    handleClick(tab) {
      if (this.mData.viewMode == "approve") return
      this.activeName = tab.name
      this.currentTab = tab.name
      this.query = {
        tab: this.activeName,
        filters: this.dataFilter.filters,
        off: this.mData.endSliceValue
      }
      this.replaceRoute()
      this.emitGlobalTabChange(this.activeName)
    },
    fn_submitForm(type) {
      if (type != "delete") {
        this.emitGlobalClickSubmitEvent(type, this.activeName)
      } else {
        this.$confirm(LanguageService.lang.c_deleteEmployeeConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(this.$router.currentRoute.params.id)
          }).catch(() => { })
      }
    },
    approveDraff(type) {
      this.$confirm(`Bạn có chắc chắn muốn ${type == 'approve' ? 'duyệt' : 'từ chối'} thông tin này không?`, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning"
      })
        .then(() => {
          EventBus.$emit('click_HSCN_approve', {
            type_button: type,
          })
        }).catch(() => { })
    },
    async fn_delete(id) {
      try {
        await EmployeeApi.delete(id)
        this.$router.push({
          name: "Admin-EmployeeManager-list"
        }).catch(() => { })
      } catch (error) {
        if (error.code == 500) {
          window.toastr.error(error.message)
        } else {
          window.toastr.error("Xóa nhân viên thất bại!")
        }
      }
    },
    fn_go() {
      this.$router.push({
        name: "Admin-EmployeeManager-list",
      })
    },
    emitGlobalClickSubmitEvent(type, activeTab) {
      let eventName = "click_" + activeTab
      EventBus.$emit(eventName, {
        type_button: type,
      })
    },
    emitGlobalRowClicked(row) {
      this.mData.rowId = row.id
      const beforeEmpId = window.localStorage.getItem('beforeEmpId')
      if (beforeEmpId != row.id) {
        this.isBeforeEmployee = false
        this.query = {
          tab: this.activeName,
          filters: this.dataFilter.filters,
          off: this.mData.endSliceValue
        }
      }
      if (this.$router.currentRoute.params.id == row.id && this.mData.viewMode == 'update') return
      this.replaceRoute()
      if (this.$router.currentRoute.params.id) {
        this.mData.routerParamId = row.id
      }
      this.mData.viewMode = "update"
      setTimeout(() => {
        EventBus.$emit("rowClick_" + this.activeName, {
          id: row.id,
        })
      }, 100)
    },
    emitGlobalRowApprovedClicked(row) {
      this.mData.rowId = row.id
      const beforeEmpId = window.localStorage.getItem('beforeEmpId')
      if (beforeEmpId != row.id) {
        this.isBeforeEmployee = false
        this.query = {
          tab: 'HSCN',
          filters: this.dataFilter.filters,
          off: this.mData.endSliceValue
        }
      }
      this.query.tab = 'HSCN'
      this.currentTab = 'HSCN'
      this.mData.routerParamId = row.id
      this.replaceRoute(true)
      setTimeout(() => {
        this.mData.viewMode = "approve"
        this.activeName = 'HSCN'
        EventBus.$emit("rowClick_HSCN_Approve", {
          id: row.id,
        })
      }, 500)
    },
    replaceRoute(haveDraff) {
      this.$router.replace({
        name: haveDraff ? 'Admin-EmployeeManager-approve' : 'Admin-EmployeeManager-update',
        params: { id: this.mData.rowId },
        query: this.query,
      })
        .catch(err => { })
    },
    emitGlobalTabChange(activeTab) {
      if (this.mData.viewMode == "create") {
        return
      }
      let eventName = "tab_" + activeTab
      EventBus.$emit(eventName)
    },
    forceUpdateUI() {
      this.$forceUpdate()
    },
    fn_findEmployee() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.dataFilter.filters = MethodService.filterTable(
            JSON.stringify(this.mData.dataSearch)
          )
          this.dataFilter.offset = 0
          this.fn_getEmployeeList()
        } else {
          MethodService.stopLadda()
          return false
        }
      })
    }
  },
  async created() {
    window.localStorage.setItem('beforeEmpId', this.$router.currentRoute.params.id)
    await this.fn_innitDataDefault()
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-create'
    ) {
      this.mData.viewMode = 'create'
      return
    }
    if (this.$router.currentRoute.params.id) {
      this.mData.routerParamId = this.$router.currentRoute.params.id
      this.mData.rowId = this.$router.currentRoute.params.id
    }
    if (this.$router.currentRoute.query.tab) {
      this.activeName = this.$router.currentRoute.query.tab
      this.currentTab = this.$router.currentRoute.query.tab
    }
    if (this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.asset_names ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.identity ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.is_broken ||
      this.$router.currentRoute.query.tab == 'TaiSan' && this.$route.query.status
    ) {
      this.query = this.$route.query
    } else {
      this.query = {
        tab: this.activeName,
        filters: this.dataFilter.filters,
      }
    }

    EventBus.$off('changeEmployeeInformation')
    EventBus.$on('changeEmployeeInformation', () => {
      this.fn_getEmployeeList()
      this.forceUpdateUI()
    })
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-update'
    ) {
      this.load()
      this.mData.viewMode = 'update'
      this.scrollToActiveEmployee(1000)
    }
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-approve'
    ) {
      this.fn_getEmployeeList()
      this.mData.viewMode = 'approve'
      this.scrollToActiveEmployee(1000)
    }
    if (
      this.$router.currentRoute.name ==
      'Admin-' + this.mData.moduleName + '-detail'
    ) {
      this.fn_getEmployeeList()
      this.mData.viewMode = 'update'
      this.scrollToActiveEmployee(500)
    }
    EventBus.$off('approveEmployeeDraff')
    EventBus.$on('approveEmployeeDraff', () => {
      this.fn_getEmployeeList()
      this.replaceRoute()
      this.mData.viewMode = 'update'
    })
    this.replaceRoute()
  },

  mounted() {
    this.mData.currentPath = this.$router.currentRoute.fullPath
  },
};
</script>

<style lang="scss" scoped>
::v-deep .isax-search-normal {
  font-size: 20px;
  color: var(--grey-icon);
}

::v-deep .search {
  position: relative;
  .form-search {
    // width: 290px;
    .el-input--prefix .el-input__inner {
      padding-left: 40px;
      border-radius: 20px !important;
      height: 36px !important;
    }
  }
  .show-hide-tab {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translate(0, -44%);
  }
}

::v-deep .el-input__prefix {
  padding-left: 5px;
}

p {
  max-width: 150px;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .div-list {
  max-width: 320px;
  width: 320px;
  max-height: calc(100vh - 100px);
  background-color: var(--white);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  .search {
    padding: 10px;
    border-bottom: 1px solid #CACACA;
  }
  .title__list-employee {
    padding-left: 15px;
    padding-right: 15px;
    p {
      font-size: 17px;
      font-weight: 600;
    }
  }
  .list-employee {
    padding: 10px 13px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    scroll-behavior: smooth;
    .list-employee {
      .el-card {
        .el-card__body {
          padding: 15px 30px 15px 10px;
          max-width: 300px;
        }
      }
    }
  }
}

.div-main-create {
  width: calc(100vw - 270px);
}

.div-main {
  width: calc(100vw - 580px);
}
.app.minisieNav__app.is-minisieNav .div-main {
  width: calc(100vw - 685px);
}
.app.minisieNav__app.is-minisieNav.is-minisizeSubNav .div-main {
  width: calc(100vw - 525px);
}

.app.minisieNav__app .div-main {
  width: calc(100vw - 890px);
}

.app.minisieNav__app.is-minisizeSubNav .div-main {
  width: calc(100vw - 700px);
}

.app.minisieNav__app .div-main-create {
  width: calc(100vw - 90px);
}

::v-deep .e-avatar .el-image {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid var(--orange);
}

.e-information .e-information__name {
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 25px;
  color: var(--orange);
}

.e-information .e-information__position {
  font-size: 13px;
  line-height: 22px;
  color: #444242;
}

.e-information .e-information__no {
  max-width: 195px;
  font-size: 13px;
  line-height: 22px;
  color: #444242;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .data_list_employee .tab-css .el-tabs .el-tabs__content {
  max-height: calc(100vh - 205px);
  overflow-y: auto;
  padding-right: 5px;
}

::v-deep .el-form-item__label {
  font-size: 14px;
}

::v-deep .tab-content {
  /* max-width: calc(100vw - 390px); */
  border: none;
}
.data_list_employee {
  margin-left: 20px;
}

::v-deep .el-tabs--card>.el-tabs__header {
  margin-bottom: 0;
  margin-left: 25px;
}

::v-deep .list-employee #active-tb {
  background-color: var(--orange) !important;

  .el-card__body .e-information p {
    color: var(--white) !important;
    font-weight: bold !important;
  }
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
  border: 1px solid #c8ced3;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 25px;
}

::v-deep .el-tabs__item.is-top.is-active {
  background-color: #66b1ff;
  color: #fff;
  border-color: #66b1ff;
  font-weight: bold;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

::v-deep .div-list .el-card__body:hover {
  cursor: pointer;
}

.employee_infomation {
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}


::v-deep .el-button span [class^=isax-] {
  font-size: 22px;

  &.icon_sax {
    margin-left: 15px;
  }

}

.icon-haveDraff {
  position: absolute;
  right: 5px;
  top: 7px;

  .fas {
    color: var(--orange);
  }
}

#active-tb {
  .icon-haveDraff {
    position: absolute;
    right: 5px;
    top: 7px;

    .fas {
      color: var(--white);
    }
  }
}

@media (max-width: 1501px) {
  p {
    max-width: 130px;
  }

  .e-information .e-information__no {
    max-width: 125px;
  }

  .app.minisieNav__app .div-main {
    width: calc(100vw - 850px);
  }
}

@media (max-width: 991px) {
  .app.minisieNav__app .div-main {
    width: calc(100vw - 310px);
  }
}
</style>
